import 'babel-polyfill'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
// 引入moment,初始化配置
import moment from 'moment'
import 'moment/locale/zh-cn'
import App from './App'
import store, { history } from './model'
import axiosInterceptor from '@/util/axios/index'
import Vconsole from 'vconsole'
// style
import './style/index.scss'

moment.locale('zh-cn')
axiosInterceptor()

render(
  <Provider store = { store } >
    <ConnectedRouter history = { history } >
      <App />
    </ConnectedRouter >
  </Provider >,
  document.getElementById('root')
)

